import { default as i18n, default as i18next } from 'components/i18n';
import { useEffect, useState } from 'react';
import type { AugmentedRealityType } from '../../../types/augmentedReality';

interface useLocalLanguageProps {
    ra: AugmentedRealityType | undefined
}

export const useLocalLanguage = ({ ra }: useLocalLanguageProps) => {

    const [currentLanguage, setCurrentLanguage] = useState(i18next.languages[0])
    const [isolatedI18n, setIsolatedI18n] = useState(i18n.cloneInstance({ lng: currentLanguage }))

    useEffect(() => {
        let defaultLanguage = ra?.welcome.defaultLanguage;
        if (defaultLanguage) {
            setCurrentLanguage(defaultLanguage)
        }
    })

    useEffect(() => {
        setIsolatedI18n(i18n.cloneInstance({ lng: currentLanguage }));
    }, [currentLanguage])

    return { isolatedI18n, currentLanguage }
}
